<template>
    <v-modal-validated title="Modificar expediente"
                       accept-button-text="Guardar"
                       close-button-text="Cerrar"
                       id="update-expedient-modal"
                       @closed="closeModal"
                       @accepted="emitUpdateEntityAndClient">
        <div class="form-container">
            <div class="row">
                <div class="col-12">
                    Selecciona la entidad y el cliente que quieres que tenga este expediente. Los anteriores serán
                    sustituidos por los que selecciones.
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="user-form">
                        <div class="form-group">
                            <label>Entidad: </label>

                            <select class="form-control" disabled v-if="entitiesOptions.length === 0">
                                <option selected>- No existen entidades en la aplicación -</option>
                            </select>

                            <Field type="text"
                                   name="entity"
                                   class="form-control border-0 p-0"
                                   v-model="entity"
                                   v-if="entitiesOptions.length !== 0">

                                <v-select-jq aria-label="Entidad"
                                             parent-id="update-expedient-modal"
                                             placeholder="- Seleccionar -"
                                             :options="entitiesOptions"
                                             :modelValue="entity"
                                             @update:modelValue="entity = $event">
                                </v-select-jq>
                            </Field>

                            <ErrorMessage name="entity"/>
                        </div>
                    </div>
                </div>

                <div class="col">
                    <div class="user-form">
                        <div class="form-group">
                            <label>Cliente: </label>

                            <select class="form-control" disabled v-if="clientsOptions.length === 0">
                                <option selected>- No existen clientes en la aplicación -</option>
                            </select>

                            <Field type="text"
                                   name="client"
                                   class="form-control border-0 p-0"
                                   v-model="client"
                                   v-if="clientsOptions.length !== 0">

                                <v-select-jq aria-label="Cliente"
                                             parent-id="update-expedient-modal"
                                             placeholder="- Seleccionar -"
                                             :options="clientsOptions"
                                             :value="client"
                                             @update:modelValue="client = $event">
                                </v-select-jq>
                            </Field>

                            <ErrorMessage name="client"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </v-modal-validated>
</template>

<script>
import VModal from "../../../general/VModal";
import VModalSlot from "../../../general/VModalSlot";
import {getAllEntitiesWithoutPagination} from "../../../../helpers/requests/RequestsEntities";
import VSelectJq from "../../../general/VSelectJQ";
import VModalValidated from "../../../general/VModalValidated";
import {getAllClientsWithoutPagination} from "../../../../helpers/requests/RequestsClients";
import * as yup from "yup";
import {updateClient} from "../../../../helpers/requests/RequestsExpedients";

export default {
    name: "ExpedientDetailUpdateEntityModal",
    components: {VModalValidated, VSelectJq, VModalSlot, VModal},
    props: {
        preselectedEntity: {
            type: String,
            required: true,
        },
        preselectedClient: {
            type: String,
            required: true,
        }
    },
    data() {
      return {
          entitiesOptions: [],
          clientsOptions: [],
          entity: null,
          client: null,
      }
    },
    methods: {
        async loadEntities() {
            let entities = await getAllEntitiesWithoutPagination();
            if (!entities.meta) {
                this.entities = entities;

                this.entitiesOptions = Object.values(entities).map((entity) => {
                    return {id: entity.id, text: entity.name + ' (' + entity.short_name + ')'};
                });
            }
        },
        async loadClients() {
            let clients = await getAllClientsWithoutPagination();

            if (!clients.meta) {
                this.clients = clients;

                this.clientsOptions = Object.values(clients).map((client) => {
                    return {id: client.id, text: client.fullName}
                });
            }
        },
        emitUpdateEntityAndClient() {
            let data = {};

            if (this.client !== null && this.client != this.preselectedClient) {
                data.client_id = this.client;
            }

            if (this.entity !== null && this.entity != this.preselectedEntity) {
                data.entity_id = this.entity;
            }

            this.$emit('updateEntityAndClient', data);
        },
        closeModal() {
            this.$emit('closed');
        }
    },
    async mounted() {
        await Promise.all([
            this.loadClients(),
            this.loadEntities(),
        ]);

        // if (!!this.preselectedClient) {
        //     this.client = this.preselectedClient;
        // }
        //
        // if (!!this.preselectedEntity) {
        //     this.entity = this.preselectedEntity;
        // }
    }
}
</script>
